var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31417",
    "data-name": "Group 31417",
    transform: "translate(0 -0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31409",
    "data-name": "Group 31409"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3598",
    "data-name": "Rectangle 3598",
    width: 18,
    height: 3,
    rx: 1.5,
    transform: "translate(0 0.056)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15565",
    "data-name": "Rectangle 15565",
    width: 18,
    height: 3,
    rx: 1.5,
    transform: "translate(0 10.056)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15566",
    "data-name": "Rectangle 15566",
    width: 18,
    height: 3,
    rx: 1.5,
    transform: "translate(0 20.056)",
    fill: "#d4d4d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeBars);
export default __webpack_public_path__ + "static/media/treeBars.f9d981522b0a8eb2eaf64e18cb252b8c.svg";
export { ForwardRef as ReactComponent };